import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
    useFetch,
    useForm,
    useGrid,
    useModal,
    useResource,
    useStore,
    useTab,
    useToast,
    usePage,
    useAuth,
} from "@/comn/hooks";
import { useTranslation } from "react-i18next";
import { Grid } from "@/comn/components";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Page, Group, Layout, Tab, Button, FormControl } from "@/comn/components";
import {
    APIS,
    URLS,
    SF_USR_FRGNR_VHCL_FORM,
    SG_VHCL_INFO_LIST,
    SF_FEE_TAB_FROM,
} from "@/tra/tancis/ptli/usr/frgnr/services/PtliUsrFrgnrService";

/*
 * Vehicle Information Details
 * !== 외국인 차량 상세 ==!
 */
export const PTLI0919005S = (props: any) => {
    const { resData, handleSave } = props;
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_cgmi0067", "auth_ptli0042", "auth_ptlianyADM"],
    });
    const { t } = useTranslation();
    const navigate = useNavigate();
    const modal = useModal();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const auth = useAuth();
    const [lcneAplyPrcssStatCd, setLcneAplyPrcssStatCd] = useState<string | undefined>(undefined);
    const [btnTp, setbtnTp] = useState("");
    const [frgnVhclRgsrBllNo, setFrgnVhclRgsrBllNo] = useState("");
    const [btnBllIssYn, setBtnBllIssYn] = useState("Y");
    const [vhclRgsrNo, setVhclRgsrNo] = useState("");
    const [isEditing, setIsEditing] = useState(false); // <-- track admin edit mode

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        usrFrgnrVhclForm: useForm({
            defaultSchema: SF_USR_FRGNR_VHCL_FORM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
        feeTabForm: useForm({
            defaultSchema: SF_FEE_TAB_FROM,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const tab = useTab({
        defaultSchema: {
            id: "tab_fee",
            schema: [{ label: t("T_FEE_DTL") }],
        },
    });

    const grid = {};

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getFrgnrVhclDtl: useFetch({
            api: (data) => {
                if (typeof data !== "undefined") {
                    return APIS.getFrgnrVhclDtl(data);
                } else {
                    return APIS.getFrgnrVhclDtl(resData);
                }
            },
            enabled: !!resData,
            onSuccess: (data) => {
                form.usrFrgnrVhclForm.setValues({
                    ...data.frgnrVhclDetail.content,
                });

                if (data.frgnrVhclDetail.content.frgnVhclRgsrBllNo != null) {
                    let frgnVhclRgsrBllNo = data.frgnrVhclDetail.content.frgnVhclRgsrBllNo;
                    let bllCstmOfceCd = frgnVhclRgsrBllNo.substring(0, 4);
                    let bllYy = frgnVhclRgsrBllNo.substring(4, 6);
                    let bllTpCd = frgnVhclRgsrBllNo.substring(6, 7);
                    let bllSrno = frgnVhclRgsrBllNo.substring(7, 14);
                    let bllDgr = frgnVhclRgsrBllNo.substring(14);
                    let bllNo = `${bllCstmOfceCd}-${bllYy}-${bllTpCd}-${bllSrno}-${bllDgr}`;

                    form.feeTabForm.setValues({
                        ...data.frgnrVhclDetail.content,
                        frgnVhclRgsrBllNo: bllNo,
                    });
                } else {
                    form.feeTabForm.setValues({
                        ...data.frgnrVhclDetail.content,
                    });
                }

                // checkbox String -> [] 변경
                if (data.frgnrVhclDetail.content.tankrYn != null && data.frgnrVhclDetail.content.tankrYn == "Y") {
                    form.usrFrgnrVhclForm.setValue("tankrYn", ["Y"]);
                }

                // checkbox String -> [] 변경
                if (
                    data.frgnrVhclDetail.content.trnsGodsIdtnYn != null &&
                    data.frgnrVhclDetail.content.trnsGodsIdtnYn == "Y"
                ) {
                    form.usrFrgnrVhclForm.setValue("trnsGodsIdtnYn", ["Y"]);
                }

                // 외국차량 신청 상태 M 이면 수수료 수정 X
                if (data.frgnrVhclDetail.content.lcneAplyPrcssStatCd == "M") {
                    form.feeTabForm.setEditable(false);
                } else if (
                    data.frgnrVhclDetail.content.lcneAplyPrcssStatCd == "H" &&
                    data.frgnrVhclDetail.content.frgnVhclRgsrBllNo != null
                ) {
                    form.feeTabForm.setEditable(false);
                }

                setLcneAplyPrcssStatCd(data.frgnrVhclDetail.content.lcneAplyPrcssStatCd);
                setFrgnVhclRgsrBllNo(data.frgnrVhclDetail.content.frgnVhclRgsrBllNo);
                setVhclRgsrNo(data.frgnrVhclDetail.content.vhclRgsrNo);
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.00006",
                });
            },
            showToast: true,
        }),
        updateFrgnrVhcl: useFetch({
            api: (data) => {
                return APIS.updateFrgnrVhcl(data);
            },
            onSuccess: (data, reqData) => {
                setIsEditing(false); // <-- exit edit mode after save
                form.usrFrgnrVhclForm.setEditable(false);

                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        if (reqData[0].type == "save") {
                            setbtnTp("edit");
                        } else if (reqData[0].type == "submit") {
                            setbtnTp("submit");
                        }

                        handleSave("update");
                        fetch.getFrgnrVhclDtl.fetch(reqData[0]); // stay on same page
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        updateFrgnrVhclPrcssStat: useFetch({
            api: (data) => {
                return APIS.updateFrgnrVhclPrcssStat(data);
            },
            onSuccess: (data, reqData) => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        handleSave("update");
                        fetch.getFrgnrVhclDtl.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        saveFrgnrVhclFee: useFetch({
            api: (data) => {
                return APIS.saveFrgnrVhclFee(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        handleSave("update");
                        fetch.getFrgnrVhclDtl.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        cnclFrgnrVhclFee: useFetch({
            api: (data) => {
                return APIS.cnclFrgnrVhclFee(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        handleSave("delete");
                        fetch.getFrgnrVhclDtl.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        updateFrgnrVhclFee: useFetch({
            api: (data) => {
                return APIS.saveFrgnrVhclFee(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00101",
                    onConfirm: () => {
                        fetch.getFrgnrVhclDtl.fetch();
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        deleteFrgnrVhcl: useFetch({
            api: (data) => {
                return APIS.deleteFrgnrVhcl(data);
            },
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003",
                    onConfirm: () => {
                        handleSave("delete");
                    },
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: error.response.data.errorMessage,
                });
            },
        }),
        getBillPrint: useFetch({
            api: (bllNo) => {
                return APIS.getBillPrint(bllNo);
            },
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: (error) => {
                modal.openModal({
                    content: "msg.00006",
                });
            },
        }),
        getFrgnrVhclC29Print: useFetch({
            api: (params) => APIS.getFrgnrVhclC29Print(params),
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: () => {
                modal.openModal({ content: "msg.00006" });
            },
        }),
        getFrgnrVhclC29LcnePrint: useFetch({
            api: (params) => APIS.getFrgnrVhclC29LcnePrint(params),
            onSuccess: (data) => {
                modal.openModal({
                    type: "pdf",
                    data: data,
                    thumbnail: true,
                    download: true,
                    print: true,
                });
            },
            onError: () => {
                modal.openModal({ content: "msg.00006" });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        updateFrgnrVhcl: (type: any) => {
            form.usrFrgnrVhclForm.handleSubmit(
                (data) => {
                    let reqData = { ...data, lcneAplyPrcssStatCd: "", type: "" };

                    if (type == "save") {
                        reqData = {
                            ...data,
                            lcneAplyPrcssStatCd: "1",
                            orgVhclRgsrNo: vhclRgsrNo,
                            type: "save",
                        };
                    } else if (type == "submit") {
                        reqData = {
                            ...data,
                            lcneAplyPrcssStatCd: "A",
                            orgVhclRgsrNo: vhclRgsrNo,
                            type: "submit",
                        };
                    } else if (type == "admin-edit") {
                        // Admin edit — keep current status, just update vehicle info
                        reqData = {
                            ...data,
                            lcneAplyPrcssStatCd: lcneAplyPrcssStatCd, // keep existing status
                            orgVhclRgsrNo: vhclRgsrNo,
                            type: "save",
                        };
                    }

                    if (data.tankrYn != null) {
                        reqData = {
                            ...reqData,
                            tankrYn: data.tankrYn.toString(),
                        };
                    }

                    if (data.trnsGodsIdtnYn != null) {
                        reqData = {
                            ...reqData,
                            trnsGodsIdtnYn: data.trnsGodsIdtnYn.toString(),
                        };
                    }

                    modal.openModal({
                        content: "msg.00101",
                        onConfirm: () => {
                            fetch.updateFrgnrVhcl.fetch(reqData);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        updateFrgnrVhclPrcssStat: (type: any) => {
            let targetStatCd = "";

            if (type == "vrfn") {
                targetStatCd = "D";
            } else if (type == "aprv") {
                targetStatCd = "H";
            } else if (type == "return") {
                targetStatCd = "4";
            }

            let reqData = {
                ...resData,
                lcneAplyPrcssStatCd: targetStatCd,
            };

            if (resData.tankrYn != null) {
                reqData = {
                    ...reqData,
                    tankrYn: resData.tankrYn.toString(),
                };
            }

            if (resData.trnsGodsIdtnYn != null) {
                reqData = {
                    ...reqData,
                    trnsGodsIdtnYn: resData.trnsGodsIdtnYn.toString(),
                };
            }

            modal.openModal({
                content: "msg.00101",
                onConfirm: () => {
                    fetch.updateFrgnrVhclPrcssStat.fetch(reqData);
                },
            });
        },
        saveFrgnrVhclFee: (type: any) => {
            form.feeTabForm.handleSubmit(
                (data) => {
                    if (type == "Y") {
                        modal.openModal({
                            content: "msg.00101",
                            onConfirm: () => {
                                const data = {
                                    ...form.feeTabForm.getValues(),
                                    coTin: form.usrFrgnrVhclForm.getValue("coTin"),
                                    lcneTpCd: form.usrFrgnrVhclForm.getValue("lcneTpCd"),
                                    appNo: form.usrFrgnrVhclForm.getValue("appNo"),
                                    lcneYy: form.usrFrgnrVhclForm.getValue("lcneYy"),
                                    vhclRgsrNo: form.usrFrgnrVhclForm.getValue("vhclRgsrNo"),
                                    cstmLcneNo: form.usrFrgnrVhclForm.getValue("cstmLcneNo"),
                                    coNm: form.usrFrgnrVhclForm.getValue("owrNm"),
                                    bllCstmOfceCd: auth.get("cstmCd"),
                                    lcneAplyPrcssStatCd: "H",
                                    frgnVhclRgsrBllIssYn: type,
                                };
                                fetch.saveFrgnrVhclFee.fetch(data);
                            },
                        });
                    } else {
                        modal.openModal({
                            content: "msg.00101",
                            onConfirm: () => {
                                const data = {
                                    coTin: form.usrFrgnrVhclForm.getValue("coTin"),
                                    lcneTpCd: form.usrFrgnrVhclForm.getValue("lcneTpCd"),
                                    appNo: form.usrFrgnrVhclForm.getValue("appNo"),
                                    lcneYy: form.usrFrgnrVhclForm.getValue("lcneYy"),
                                    vhclRgsrNo: form.usrFrgnrVhclForm.getValue("vhclRgsrNo"),
                                    cstmLcneNo: form.usrFrgnrVhclForm.getValue("cstmLcneNo"),
                                    coNm: form.usrFrgnrVhclForm.getValue("owrNm"),
                                    bllCstmOfceCd: auth.get("cstmCd"),
                                    lcneAplyPrcssStatCd: "M",
                                    frgnVhclRgsrBllIssYn: type,
                                };
                                fetch.saveFrgnrVhclFee.fetch(data);
                            },
                        });
                    }
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        cnclFrgnrVhclFee: (type: any) => {
            form.feeTabForm.handleSubmit(
                (data) => {
                    modal.openModal({
                        content: "msg.00101",
                        onConfirm: () => {
                            const data = {
                                ...form.feeTabForm.getValues(),
                                coTin: form.usrFrgnrVhclForm.getValue("coTin"),
                                lcneTpCd: form.usrFrgnrVhclForm.getValue("lcneTpCd"),
                                appNo: form.usrFrgnrVhclForm.getValue("appNo"),
                                lcneYy: form.usrFrgnrVhclForm.getValue("lcneYy"),
                                vhclRgsrNo: form.usrFrgnrVhclForm.getValue("vhclRgsrNo"),
                                cstmLcneNo: form.usrFrgnrVhclForm.getValue("cstmLcneNo"),
                                coNm: form.usrFrgnrVhclForm.getValue("owrNm"),
                                bllCstmOfceCd: auth.get("cstmCd"),
                                frgnVhclRgsrBllIssYn: type,
                            };
                            fetch.cnclFrgnrVhclFee.fetch(data);
                        },
                    });
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        deleteFrgnrVhcl: form.usrFrgnrVhclForm.handleSubmit(
            (data) => {
                const reqData = {
                    coTin: data.coTin,
                    lcneYy: data.lcneYy,
                    vhclRgsrNo: data.vhclRgsrNo,
                    amdDgr: data.amdDgr,
                    appDgr: data.appDgr,
                };

                modal.openModal({
                    content: "msg.00101",
                    onConfirm: () => {
                        fetch.deleteFrgnrVhcl.fetch(reqData);
                    },
                });
            },
            () => {
                toast.showToast({ type: "warning", content: "msg.00002" });
            },
        ),
    };

    const render = {};

    const bllIssYn = form.feeTabForm.watch("frgnVhclRgsrBllIssYn");

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.usrFrgnrVhclForm.setEditable(false);
    }, []);

    return (
        <Page info={true}>
            <Group>
                <Group.Body>
                    <Layout direction="col" gap={4}>
                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_VHCL_INFO")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>

                                    <Group.Section>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.vhclRgsrNo}
                                                controlSize={10}
                                            ></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.owrNm}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.issRegnNm}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.appNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.cardRgsrNo}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.trptAppNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.trptLcneNo}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.trptIssDtm}></Group.Control>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.insrCvrPtclCn}
                                            ></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                        <Group.Control
                                            {...form.usrFrgnrVhclForm.schema.latraCrteNo}
                                        ></Group.Control>
                                        <Group.Control
                                            {...form.usrFrgnrVhclForm.schema.atcdFileDto}
                                        ></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.vhclMkerNm}></Group.Control>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.vhclBodyTpNm}
                                            ></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.mnfcYy}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.vhclClrNm}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.engnNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.chssNo}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.vhclDpacInfoCn}
                                            ></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.vhclAxleNo}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.carygCapc}></Group.Control>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.trptVhclMlg}
                                            ></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.emptWght}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.tankrYn}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Label label={t("L_TRANS_GODS_YN")} labelSize={12}></Group.Label>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.trnsGodsIdtnYn}
                                                only="control"
                                            />
                                        </Group.Row>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>
                    </Layout>

                    <Layout direction="col" gap={4}>
                        <Group.Section>
                            <Layout direction="col" gap={4}>
                                <Layout direction="col">
                                    <Layout>
                                        <Layout.Left>
                                            <Group.Title title={t("T_LCNE")} titleSize={2}></Group.Title>
                                        </Layout.Left>
                                    </Layout>
                                    <Group.Section>
                                        <Group.Row>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.trptLcneNo}></Group.Control>
                                            <Group.Control {...form.usrFrgnrVhclForm.schema.lcneIssDtm}></Group.Control>
                                        </Group.Row>
                                        <Group.Row>
                                            <Group.Control
                                                {...form.usrFrgnrVhclForm.schema.lcneVldtyDays}
                                                controlSize={10}
                                            ></Group.Control>
                                        </Group.Row>
                                    </Group.Section>
                                </Layout>
                            </Layout>
                        </Group.Section>
                    </Layout>

                    <Layout direction="row">
                        <Layout.Right>
                            {/* Admin Edit button — visible only for users with auth_ptli0066, when not editing */}
                            {!isEditing && btnTp != "save" && auth.get("authList")?.includes("auth_ptli0066") && (
                                <Button
                                    role="edit"
                                    onClick={() => {
                                        setIsEditing(true);
                                        form.usrFrgnrVhclForm.setEditable(true);
                                    }}
                                />
                            )}

                            {/* Admin Save button — visible only when in edit mode */}
                            {isEditing && (
                                <Button
                                    role="save"
                                    onClick={() => {
                                        handler.updateFrgnrVhcl("admin-edit");
                                    }}
                                />
                            )}

                            {/* Admin Cancel edit button */}
                            {isEditing && (
                                <Button
                                    role="cancel"
                                    onClick={() => {
                                        setIsEditing(false);
                                        form.usrFrgnrVhclForm.setEditable(false);
                                        fetch.getFrgnrVhclDtl.fetch(); // reload original data
                                    }}
                                />
                            )}

                            {/* Status-based action buttons — hidden when editing */}
                            {!isEditing && (
                                <>
                                    {lcneAplyPrcssStatCd == "A" && (
                                        <>
                                            <Button
                                                variant="secondary"
                                                onClick={() => {
                                                    handler.updateFrgnrVhclPrcssStat("vrfn");
                                                }}
                                            >
                                                {t("B_VRFN_RSLT")}
                                            </Button>
                                            <Button
                                                variant="secondary"
                                                onClick={() => {
                                                    handler.updateFrgnrVhclPrcssStat("return");
                                                }}
                                            >
                                                {t("B_RETURN")}
                                            </Button>
                                        </>
                                    )}

                                    {lcneAplyPrcssStatCd == "D" && (
                                        <Button
                                            variant="secondary"
                                            onClick={() => {
                                                handler.updateFrgnrVhclPrcssStat("aprv");
                                            }}
                                        >
                                            {t("B_APRV_RSLT")}
                                        </Button>
                                    )}

                                    {lcneAplyPrcssStatCd == "1" && btnTp != "submit" && (
                                        <>
                                            <Button
                                                role="submit"
                                                onClick={() => {
                                                    handler.updateFrgnrVhcl("submit");
                                                }}
                                            />
                                            <Button
                                                role="delete"
                                                onClick={() => {
                                                    handler.deleteFrgnrVhcl();
                                                }}
                                            />
                                        </>
                                    )}
                                </>
                            )}

                            <Button
                                role="close"
                                onClick={() => {
                                    modal.closeModal();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>

            {lcneAplyPrcssStatCd == "H" || lcneAplyPrcssStatCd == "M" ? (
                <Group>
                    <Group.Body>
                        <Tab {...tab.tab}>
                            <Tab.Panel>
                                <Group.Section>
                                    <Layout direction="col" gap={4}>
                                        <Group.Section>
                                            <Layout direction="col" gap={4}>
                                                <Layout direction="col">
                                                    <Group.Section>
                                                        <Group.Row>
                                                            <Group.Control
                                                                {...form.feeTabForm.schema.frgnVhclRgsrBllIssYn}
                                                                onChange={(value) => {
                                                                    if (value == "N") {
                                                                        form.feeTabForm.setEditable(
                                                                            "frgnVhclRgsrRcptNo",
                                                                            false,
                                                                        );
                                                                        form.feeTabForm.setEditable(
                                                                            "frgnVhclRgsrBllNo",
                                                                            false,
                                                                        );
                                                                        form.feeTabForm.setEditable("payTpCd", false);
                                                                        form.feeTabForm.setSchema("payTpCd", {
                                                                            required: false,
                                                                        });
                                                                        form.feeTabForm.setEditable(
                                                                            "frgnVhclRgsrFeeVal",
                                                                            false,
                                                                        );
                                                                        form.feeTabForm.setSchema(
                                                                            "frgnVhclRgsrFeeVal",
                                                                            { required: false },
                                                                        );
                                                                        form.feeTabForm.setEditable(
                                                                            "frgnVhclRgsrFeeTzsVal",
                                                                            false,
                                                                        );
                                                                        form.feeTabForm.setEditable(
                                                                            "frgnVhclRgsrRcptDtm",
                                                                            false,
                                                                        );
                                                                        form.feeTabForm.setEditable(
                                                                            "frgnVhclRgsrBllIssDtm",
                                                                            false,
                                                                        );
                                                                        form.feeTabForm.setEditable(
                                                                            "frgnVhclRgsrPayDtm",
                                                                            false,
                                                                        );
                                                                        form.feeTabForm.setValues({
                                                                            frgnVhclRgsrRcptNo: "",
                                                                            frgnVhclRgsrBllNo: "",
                                                                            payTpCd: "",
                                                                            frgnVhclRgsrFeeVal: "",
                                                                            frgnVhclRgsrFeeTzsVal: "",
                                                                            frgnVhclRgsrRcptDtm: "",
                                                                            frgnVhclRgsrBllIssDtm: "",
                                                                            frgnVhclRgsrPayDtm: "",
                                                                        });
                                                                    } else {
                                                                        form.feeTabForm.setEditable(true);
                                                                        form.feeTabForm.setSchema("payTpCd", {
                                                                            required: true,
                                                                        });
                                                                        form.feeTabForm.setValues({
                                                                            payTpCd: "R",
                                                                            frgnVhclRgsrFeeVal: 300,
                                                                        });
                                                                    }
                                                                    setBtnBllIssYn(value);
                                                                }}
                                                            ></Group.Control>
                                                            <Group.Control
                                                                {...form.feeTabForm.schema.payTpCd}
                                                            ></Group.Control>
                                                        </Group.Row>
                                                        <Group.Row>
                                                            <Group.Control
                                                                {...form.feeTabForm.schema.frgnVhclRgsrBllNo}
                                                                readOnly
                                                            ></Group.Control>
                                                            <Group.Control
                                                                {...form.feeTabForm.schema.frgnVhclRgsrRcptNo}
                                                                readOnly
                                                            ></Group.Control>
                                                        </Group.Row>
                                                        <Group.Row>
                                                            <Group.Control
                                                                {...form.feeTabForm.schema.frgnVhclRgsrFeeVal}
                                                            ></Group.Control>
                                                            <Group.Control
                                                                {...form.feeTabForm.schema.frgnVhclRgsrFeeTzsVal}
                                                                readOnly
                                                            ></Group.Control>
                                                        </Group.Row>
                                                        <Group.Row>
                                                            <Group.Control
                                                                {...form.feeTabForm.schema.frgnVhclRgsrBllIssDtm}
                                                                readOnly
                                                            ></Group.Control>
                                                            <Group.Control
                                                                {...form.feeTabForm.schema.frgnVhclRgsrRcptDtm}
                                                                readOnly
                                                            ></Group.Control>
                                                        </Group.Row>
                                                    </Group.Section>
                                                </Layout>
                                            </Layout>
                                        </Group.Section>
                                        <Layout direction="row">
                                            <Layout.Right>
                                                {lcneAplyPrcssStatCd == "H" &&
                                                btnBllIssYn == "Y" &&
                                                frgnVhclRgsrBllNo == null ? (
                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => {
                                                            handler.saveFrgnrVhclFee("Y");
                                                        }}
                                                    >
                                                        {t("B_RGST_BLL")}
                                                    </Button>
                                                ) : null}

                                                {lcneAplyPrcssStatCd == "H" && btnBllIssYn == "N" ? (
                                                    <Button
                                                        role="save"
                                                        onClick={() => {
                                                            handler.saveFrgnrVhclFee("N");
                                                        }}
                                                    ></Button>
                                                ) : null}

                                                {lcneAplyPrcssStatCd == "H" && frgnVhclRgsrBllNo != null ? (
                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => {
                                                            handler.cnclFrgnrVhclFee(btnBllIssYn);
                                                        }}
                                                    >
                                                        {t("B_DEL_BLL")}
                                                    </Button>
                                                ) : null}

                                                {lcneAplyPrcssStatCd == "H" && frgnVhclRgsrBllNo != null ? (
                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => {
                                                            fetch.getFrgnrVhclC29Print.fetch({
                                                                coTin:
                                                                    form.usrFrgnrVhclForm?.getValue?.("coTin") || "",
                                                                lcneYy:
                                                                    form.usrFrgnrVhclForm?.getValue?.("lcneYy") || "",
                                                                vhclRgsrNo:
                                                                    form.usrFrgnrVhclForm?.getValue?.("vhclRgsrNo") || "",
                                                            });
                                                        }}
                                                    >
                                                        {t("B_BLL_PRNT")}
                                                    </Button>
                                                ) : null}

                                                {lcneAplyPrcssStatCd == "M" ? (
                                                    <Button
                                                        variant="secondary"
                                                        onClick={() => {
                                                            fetch.getFrgnrVhclC29LcnePrint.fetch({
                                                                coTin:
                                                                    form.usrFrgnrVhclForm?.getValue?.("coTin") || "",
                                                                lcneYy:
                                                                    form.usrFrgnrVhclForm?.getValue?.("lcneYy") || "",
                                                                vhclRgsrNo:
                                                                    form.usrFrgnrVhclForm?.getValue?.("vhclRgsrNo") || "",
                                                            });
                                                        }}
                                                    >
                                                        Print C29-License
                                                    </Button>
                                                ) : null}
                                            </Layout.Right>
                                        </Layout>
                                    </Layout>
                                </Group.Section>
                            </Tab.Panel>
                        </Tab>
                    </Group.Body>
                </Group>
            ) : null}
        </Page>
    );
};